import { render, staticRenderFns } from "./LiveSchedule.vue?vue&type=template&id=625ff528&scoped=true&"
import script from "./LiveSchedule.vue?vue&type=script&lang=js&"
export * from "./LiveSchedule.vue?vue&type=script&lang=js&"
import style0 from "./LiveSchedule.vue?vue&type=style&index=0&id=625ff528&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "625ff528",
  null
  
)

export default component.exports